export const progressInfosFactory = ({
  registration,
}: {
  registration: string;
}) => [
  {
    title: `Info For ${registration.replace("+", " ")}`,
    path: `/checkout/info/buy/${registration}`,
  },
  {
    title: "Customise & Options",
    path: `/checkout/customise/${registration}`,
  },
  {
    title: "Review & Payment",
    path: `/checkout/payment/${registration}`,
  },
  {
    title: "Thank you page",
    path: `/secure/buy/thanks?registration=${registration}`,
  },
];

export const sizeKeys = {
  Regular: "regular",
  Large: "large",
  Square: "square",
  Motorbike: "motorbike",
};

export const fontKeys = {
  Standard: "standard",
  "3D": "3d",
  Carbon: "carbon",
  "Hi-line": "hi-line",
};

export const logoKeys = {
  None: "no_logo",
  "GB Euro": "qbeuro",
  England: "england",
  UK: "uk",
  Scotland: "scotland",
  Wales: "wales",
  ev: "ev",
};

export const borderKeys = {
  border_no: "border_no",
  border_yes: "border_yes",
};
